import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Carousel, Container } from "react-bootstrap";

import { getService } from "../../redux/slices/ServiceListSlice";

import HeaderBlue from "../Header/HeaderBlue";
import CardBlock from "./CardBlock";

import styles from "./ServiceBlock.module.scss";

const ServiceBlock = () => {
  const dispatch = useDispatch();
  const { serviceList = [] } = useSelector((state) => state.serviceList || {});

  useEffect(() => {
    dispatch(getService());
  }, [dispatch]);

  const sortedService = useMemo(() => {
    return [...serviceList].sort((a, b) => (a?.id || 0) - (b?.id || 0));
  }, [serviceList]);

  const [activeIndex, setActiveIndex] = useState(0);
  const count = sortedService.length;

  const handleSelect = (selectedIndex) => {
    setActiveIndex(selectedIndex);
  };

  const prev = () => {
    if (!count) return;
    setActiveIndex((idx) => (idx - 1 + count) % count);
  };

  const next = () => {
    if (!count) return;
    setActiveIndex((idx) => (idx + 1) % count);
  };

  return (
    <div className={styles.root}>
      <Container>
        <HeaderBlue />
      </Container>

      <div className={styles.carouselWrapper}>
        <Carousel
          data-bs-theme="dark"
          className={styles.carousel}
          activeIndex={activeIndex}
          onSelect={handleSelect}
          controls={false}
          touch={true}
          interval={5000}
          pause="hover"
          keyboard
          indicators
        >
          {sortedService.map((val) => (
            <Carousel.Item key={val?.id ?? Math.random()}>
              <CardBlock {...val} />
            </Carousel.Item>
          ))}
        </Carousel>

        {count > 1 && (
          <>
            <button
              type="button"
              className={`${styles.arrow} carousel-control-prev`}
              aria-label="Previous"
              onClick={prev}
            >
              <span className="carousel-control-prev-icon" aria-hidden="true" />
              <span className="visually-hidden">Previous</span>
            </button>

            <button
              type="button"
              className={`${styles.arrow} carousel-control-next`}
              aria-label="Next"
              onClick={next}
            >
              <span className="carousel-control-next-icon" aria-hidden="true" />
              <span className="visually-hidden">Next</span>
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default ServiceBlock;
